import { Font } from '@react-pdf/renderer';
import robotoNormal from '../../../../assets/fonts/roboto/roboto-regular-webfont.ttf';
import robotoBold from '../../../../assets/fonts/roboto/roboto-bold-webfont.ttf';

export const RegisterFont = () => {
    return Font.register({
        family: 'Roboto',
        fonts: [
            { src: robotoNormal, fontWeight: 'normal' },
            { src: robotoBold, fontWeight: 'bold' },
        ],
    });
};
